
import axios from "axios";
import { baseUrl } from "../../nametitle/dataUrl";
import { saveDataToFile } from "../SearchAction";
import { Localvalue } from "../../nametitle/localValue";

export const CreateNewParameter = async (test) => {
  var data = JSON.stringify({
    "test": test
  });
  var config = {
    method: 'post',
    url: `${baseUrl.baseUrl}/api/v1/manager-pages/`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: data
  };
  await axios(config)
    .then(function (response) {
      // //console.log(JSON.stringify(response.data));
      window.location.reload();
    })
    .catch(function (error) {
      // //console.log(error);
    });
}



// Load
export const LoadAllAccueil = async (
  /******************************************** Accueil */
  id,
  videoIntro, coverPicture1, description1, title1,
  // Activité 2
  coverPicture2, verset, title2, description2, description3,
  /******************************************** About */
  coverPicture3, description4, title3,
  /******************************************* Contact */
) => {
  axios.get(`${baseUrl.baseUrl}/api/v1/manager-pages/get/all`, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then(function (response) {
      // //console.log(JSON.stringify(response.data.data[0]));
      saveDataToFile(response.data.data[0],Localvalue.activitePageData);
      id(response.data.data[0]._id);
      // ***************************************************     Activté 1
      // activité Accueil 1
      videoIntro(response.data.data[0].accueil.activite1.video);
      coverPicture1(response.data.data[0].accueil.activite1.coverPicture);
      title1(response.data.data[0].accueil.activite1.title);
      description1(response.data.data[0].accueil.activite1.description);
      // ***************************************************     Activté 2
      verset(response.data.data[0].accueil.activite2.verset);
      coverPicture2(response.data.data[0].accueil.activite2.coverPicture);
      title2(response.data.data[0].accueil.activite2.title);
      description2(response.data.data[0].accueil.activite2.description1);
      description3(response.data.data[0].accueil.activite2.description2);
      // *****************************************************   Activté 3
      coverPicture3(response.data.data[0].accueil.activite3.coverPicture);
      title3(response.data.data[0].accueil.activite3.title);
      description4(response.data.data[0].accueil.activite3.description);

    })
    .catch(function (error) {
      // //console.log(error);
    });
}




// Chargement des comosant de la page d'accueil 
export const LoadAllAccueilComposant = async (
  setState
) => {
  axios.get(`${baseUrl.baseUrl}/api/v1/manager-pages/get/all`, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then(function (response) {
      // //console.log(JSON.stringify(response.data.data[0]));
      saveDataToFile(response.data.data[0],Localvalue.activitePageData);
      setState(response.data.data);
    })
    .catch(function (error) {
      // //console.log(error);
    });
}




export const LoadAllAbout = async (
  /******************************************** Accueil */
  id,
  videoIntro, coverPicture1,title1,description1,strategy,content,
  // Activité 2
  coverPicture2, title2, description2
   ) => {
  axios.get(`${baseUrl.baseUrl}/api/v1/manager-pages/get/all`, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then(function (response) {
      // //console.log(JSON.stringify(response.data.data[0]));
      saveDataToFile(response.data.data[0],Localvalue.activitePageData);

      id(response.data.data[0]._id);

      // ***************************************************     Activté 1
      // activité Accueil 1
      videoIntro(response.data.data[0].about.activite1.video);
      coverPicture1(response.data.data[0].about.activite1.coverPicture);
      title1(response.data.data[0].about.activite1.title);
      content(response.data.data[0].about.activite1.content);
      description1(response.data.data[0].about.activite1.description);
      strategy(response.data.data[0].about.activite1.strategy);
      // ***************************************************     Activté 2
      
      coverPicture2(response.data.data[0].about.activite2.coverPicture);
      title2(response.data.data[0].about.activite2.title);
      description2(response.data.data[0].about.activite2.description);

    })
    .catch(function (error) {
      // //console.log(error);
    });
}



export const LoadAllContact = async (
  id,logo, name,coverPicture,
  email,telephone1,telephone2,telephone3,
  facebook, youtube, instagram
   ) => {
  axios.get(`${baseUrl.baseUrl}/api/v1/manager-pages/get/all`, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then(function (response) {
      // //console.log(JSON.stringify(response.data.data[0]));
      saveDataToFile(response.data.data[0],Localvalue.activitePageData)

      id(response.data.data[0]._id);
      // ***************************************************     Activté 1
      // activité Accueil 1
      logo(response.data.data[0].contact.activite1.logo);
      name(response.data.data[0].contact.activite1.name);
      coverPicture(response.data.data[0].contact.activite1.coverPicture);
      // ***************************************************     Activté 3
      email(response.data.data[0].contact.activite2.email);
      telephone1(response.data.data[0].contact.activite2.telephone1);
      telephone2(response.data.data[0].contact.activite2.telephone2);
      telephone3(response.data.data[0].contact.activite2.telephone3);
      // ***************************************************     Activté 3
      facebook(response.data.data[0].contact.activite3.facebook);
      youtube(response.data.data[0].contact.activite3.youtube);
      instagram(response.data.data[0].contact.activite3.instagram);

    })
    .catch(function (error) {
      //console.log(error);
    });
}







export const LoadAllContactFooter = async (logo,email,telephone1,telephone2,telephone3) => {
  axios.get(`${baseUrl.baseUrl}/api/v1/manager-pages/get/all`, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then(function (response) {
      //console.log(JSON.stringify(response.data.data[0]));
      saveDataToFile(response.data.data[0],Localvalue.activitePageData);
      // ***************************************************     Activté 1
      // activité Accueil 1
      telephone1(response.data.data[0].contact.activite2.telephone1);
      telephone2(response.data.data[0].contact.activite2.telephone2);
      telephone3(response.data.data[0].contact.activite2.telephone3);
      email(response.data.data[0].contact.activite2.email);
      logo(response.data.data[0].contact.activite1.logo);
    })
    .catch(function (error) {
      //console.log(error);
    });
}












export const UpdateAccueil = async (
  /******************************************** Accueil */
  id,
  videoIntro, coverPicture1, description1, title1,
  // Activité 2
  coverPicture2, verset, title2, description2, description3,
  /******************************************** About */
  coverPicture3, description4, title3,
  /******************************************* Contact */
) => {

  var data = JSON.stringify({
    "accueil": {
      // Activité n°1
      "activite1": {
        "video": videoIntro,
        "coverPicture": coverPicture1,
        "description": description1,
        "title": title1,
      },
      // Activité n°2
      "activite2": {
        "coverPicture": coverPicture2,
        "title": title2,
        "verset":verset,
        "description1": description2,
        "description2": description3,
      },
      "activite3": {
        "coverPicture": coverPicture3,
        "description1": description4,
        "title": title3,
      }
    }
  });
  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/manager-pages/${id}`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: data
  };
  await axios(config)
    .then(function (response) {
      //console.log(JSON.stringify(response.data.data));
      window.location.reload();
    })
    .catch(function (error) {
      //console.log(error);
    });
}




export const UpdateAbout = async (
  /******************************************** Accueil */
  id,
  videoIntro, coverPicture1, title1,content,
  // Activité 2
  coverPicture2, title2, description2,
) => {

  var data = JSON.stringify({
    "about": {
      // Activité n°1
      "activite1": {
        "video": videoIntro,
        "coverPicture": coverPicture1,
        "title": title1,
        "content": content,
      },
      // Activité n°2
      "activite2": {
        "coverPicture": coverPicture2,
        "title": title2,
        "description": description2,
      }
    }
  });
  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/manager-pages/${id}`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: data
  };
  await axios(config)
    .then(function (response) {
      //console.log(JSON.stringify(response.data.data));
      window.location.reload();
    })
    .catch(function (error) {
      //console.log(error);
    });
}







export const UpdateContact = async (
  id,logo, name,coverPicture,
  email,telephone1,telephone2,telephone3,
  facebook, youtube, instagram
) => {

  var data = JSON.stringify({
    "contact": {
      // Activité n°1
      "activite1": {
        "logo": logo,
        "coverpicture": coverPicture,
        "name": name,
      },
      // Activité n°2
      "activite2": {
        "email": email,
        "telephone1": telephone1,
        "telephone2": telephone2,
        "telephone3": telephone3,
      },
      "activite3":{
        "facebook": facebook,
        "youtube": youtube,
        "instainstagram":instagram
      }
    }
  });
  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/manager-pages/${id}`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: data
  };
  await axios(config)
    .then(function (response) {
      //console.log(JSON.stringify(response.data.data));
      window.location.reload();
    })
    .catch(function (error) {
      //console.log(error);
    });
}
